import styled from "styled-components"
import Div from "../div/div.component"

export const EmailSubscribeHorizontalContainer = styled(Div)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 24px;
  grid-template-areas:
    "title form"
    "disclaimer form";

  background-color: #fff;
  box-shadow: 1px 2px 20px rgba(19, 15, 235, 0.1);
  padding: 45px;
  margin-top: 100px;

  @media only screen and (max-width: 1050px) {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto auto;
    grid-template-areas:
      "title"
      "form"
      "disclaimer";
    margin-top: 60px;
    padding: 25px;
  }
`

export const EmailSubscribeHorizontalTitle = styled.h5`
  ${({ theme: { typography } }) => typography.desktop.h5};
  grid-area: title;
  margin: 0;

  @media only screen and (max-width: 1050px) {
    margin-bottom: 25px;
  }
`

export const EmailSubscribeHorizontalSubTitle = styled.p`
  ${({ theme: { typography } }) => typography.desktop.metadata};
  grid-area: disclaimer;
  margin: 0;
  margin-top: 10px;
  @media only screen and (max-width: 760px) {
    margin-top: 0px;
  }
`

export const EmailSubscribeHorizontalRightContainer = styled.div`
  position: relative;
  grid-area: form;
  margin-left: 30px;

  @media only screen and (max-width: 1050px) {
    margin-left: 0;
  }
`

export const EmailSubscribeHorizontalFormContainer = styled.div`
  display: flex;

  button {
    height: 46px;
    align-self: flex-start !important;
    background-color: ${({ theme: { colors } }) => colors.accentPink};
    color: ${({ theme: { colors } }) => colors.white};
    margin: 0;
    margin-left: 10px;
    font-size: 15px;
  }

  @media only screen and (max-width: 760px) {
    display: unset;

    button {
      width: 100%;
      margin: 10px 0;
    }
  }
`

export const EmailSubscribeHorizontalError = styled.h5`
  position: relative;
  top: -10px;

  ${({ theme: { typography } }) => typography.desktop.metadata};
  color: #eb000e;
  font-weight: bold;
  margin: 0;

  @media only screen and (max-width: 760px) {
    top: 0;
    margin-bottom: 10px;
  }
`

const iconStylingDesktop = ({ statusStyle }) => {
  if (statusStyle === "success") return `top: 11px;`
  if (statusStyle === "error") return `top: 24px;`
}

const iconStylingMobile = ({ statusStyle }) => {
  if (statusStyle === "success") return `top: 11px;`
  if (statusStyle === "error")
    return `@media only screen and (max-width: 760px) {top: 34px;};@media only screen and (max-width: 380px) {top: 54px;}`
}

export const StatusIcon = styled.div`
  position: absolute;
  right: 177px;
  ${iconStylingDesktop};

  @media only screen and (max-width: 760px) {
    right: 9px;
    ${iconStylingMobile};
  }
`

const inputStateStyling = ({ statusStyle }) => {
  if (statusStyle === "success") return `border: 1px solid green;`
  if (statusStyle === "error") return `border: 1px solid #EB000E;`
}

export const EmailSubscribeHorizontalInput = styled.input`
  padding: 10px 20px;
  height: 46px;
  width: 100%;
  border-radius: 999px; /* make sure element is fully rounded  */
  border: 1px solid ${({ theme: { colors } }) => colors.formGrey};
  background-color: #ffffff;
  ${inputStateStyling};
  font-size: 16px;
`
